var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 101,
    viewBox: "0 0 475 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48,
    clipPath: "url(#clip0_28205:10807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446 0C505.5 0 505 31.5 567 31.5V111.5H92V31.5C121 31.5 146.5 12 208.5 12C270.5 12 262 36.5 324.5 36.5C361 36.5 385.5 0 446 0Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 0C30.5 0 30 31.5 92 31.5V111.5H-383V31.5C-354 31.5 -328.5 12 -266.5 12C-204.5 12 -213 36.5 -150.5 36.5C-114 36.5 -89.5 0 -29 0Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.255 2C61.6295 2 62.1305 33.6413 0 33.6413V114H476V33.6413C446.939 33.6413 421.385 14.0538 359.255 14.0538C297.124 14.0538 305.642 38.6637 243.011 38.6637C206.434 38.6637 181.882 2 121.255 2Z",
    fill: "#C6C6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28205:10807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 475,
    height: 101,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWater);
export default __webpack_public_path__ + "static/media/bottom-water.5d0f9ce1147b0e64128a5c379f93e5d5.svg";
export { ForwardRef as ReactComponent };